/* global */

import './style.less';
import sponsorModalTemplate from 'modals/certificateSponsorInfo/template.html';
import sponsorModalController from 'modals/certificateSponsorInfo';
import { sponsors } from '@prolaera/library';

export default function($log, $uibModal) {
  'ngInject';
  const vm = this;

  vm.$onChanges = activate;
  vm.sponsorInfoModal = () => {
    $uibModal.open({
      template: sponsorModalTemplate,
      size: 'lg',
      backdrop: true,
      windowClass: 'modal',
      controller: sponsorModalController()
    });
  };

  function activate() {
    $log.debug('Sponsors Component Activated');

    vm.sponsors = sponsors;

    vm.columnWidths = {
      checkbox: 'col-lg-2 col-md-2 col-sm-2 col-xs-12',
      form: 'col-lg-10 col-md-10 col-sm-10 col-xs-12'
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/controller.js